export const prerender = true;
export const trailingSlash = 'always';
export const ssr = false;
